import { render } from "./TCMathGamesListItem.vue?vue&type=template&id=94297d6e&scoped=true"
import script from "./TCMathGamesListItem.vue?vue&type=script&lang=js"
export * from "./TCMathGamesListItem.vue?vue&type=script&lang=js"

import "./TCMathGamesListItem.vue?vue&type=style&index=0&id=94297d6e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tunescrib-rs/tunescrib-rs/dev.tunescrib.com-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94297d6e"]])

export default __exports__